import Axios from "../plugins/Axios";
import {
  CreateTransaction,
  GetQuery,
  GetResponse,
  ServiceResult,
} from "../models/Souvenir";

const getError = (error: unknown) => {
  const value = error as {
    message?: string | string[];
    code?: string;
  } | null;

  const message = Array.isArray(value?.message)
    ? value?.message.join(", ")
    : value?.message;

  return {
    success: false as const,
    message:
      error instanceof TypeError
        ? "ไม่สามารถรับผลลัพธ์จากระบบได้"
        : message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    code: value?.code,
  };
};

const getSouvenirs = async (
  query: GetQuery
): Promise<ServiceResult<GetResponse>> => {
  try {
    const { data } = await Axios.get<{ data: GetResponse }>("/souvenirs", {
      params: query,
    });

    return {
      success: true,
      data: data.data,
    };
  } catch (error: unknown) {
    return getError(error);
  }
};

const createSouvenirTransaction = async (
  body: CreateTransaction
): Promise<ServiceResult<undefined>> => {
  try {
    await Axios.post("/transaction", body);

    return {
      success: true,
      data: undefined,
    };
  } catch (error: unknown) {
    return getError(error);
  }
};

export {
  getSouvenirs as GetSouvenirs,
  createSouvenirTransaction as CreateSouvenirTransaction,
};